import Layout from '../views/layout/layout'

//商家管理
export  default {
    path:'/merchant',
        name:'merchant',
    component:Layout,
    children:[
    {
        path: '/merchant/merchant/index',
        name: 'merchantIndex',
        component:()=>import('../views/merchant/merchant/index'),
        meta: {title: '商家管理',keepAlive:true}
    },
    {
        path: '/merchant/member/index',
        name: 'memberIndex',
        component:()=>import('../views/merchant/member/index'),
        meta: {title: 'Ec用户绑定',keepAlive:true}
    },
    {
        path: '/shops/shops/index',
        name: 'shopsIndex',
        component:()=>import('../views/merchant/shop/index'),
        meta: {title: '店铺管理',keepAlive:true}
    },
    {
        path: '/reform/supply/index',
        name: 'reformSupplyIndex',
        component:()=>import('../views/merchant/reformSupply/index'),
        meta: {title: '拆改建供应商管理',keepAlive:true}
    },
    {
        path: '/merchant/merchant/add',
        name: 'merchantAdd',
        component:()=>import('../views/merchant/merchant/add'),
        meta: {title: '新增/修改商家'}
    },
    {
        path: '/merchant/merchant/bill',
        name: 'merchantBill',
        component:()=>import('../views/merchant/merchant/bill'),
        meta: {title: '开票信息维护'}
    },
    {
        path: '/merchant/merchant/contract',
        name: 'merchantContract',
        component:()=>import('../views/merchant/merchant/contract'),
        meta: {title: '合同信息维护'}
    },
]
}